module.exports = __webpack_public_path__ + "img/lex.0a365765.jpeg";